import { Metamodel } from 'app/model/base/model';
import { CopySink } from 'app/model/pipeline/copysink/copysink';
import { SqlPoolSink } from 'app/model/pipeline/copysink/sql-pool.copysink';
import { format } from './string.util';
import { CopyActivity } from 'app/model/pipeline/copy.activity';

export function getConnectionAsSourceDirectCopyErrorMessage(
    conditionTemplate: string,
    fieldName: string,
    connectionName: string,
    pattern: 'onlySupport' | 'notSupport' = 'onlySupport',
    addSuggestion: boolean = true
): string {
    return getDirectCopyErrorMessage(
        stringResources.From,
        conditionTemplate,
        fieldName,
        connectionName,
        pattern,
        addSuggestion
    );
}

export function getConnectionAsSinkDirectCopyErrorMessage(
    activity: CopyActivity,
    conditionTemplate: string,
    fieldName: string,
    connectionName: string,
    pattern: 'onlySupport' | 'notSupport' = 'onlySupport',
    addSuggestion: boolean = true,
): string {
    const sourceDataset = activity.sourceDataset;
    if (sourceDataset?.isSampleDataset) {
        return format(stringResources.DirectCopyToConnectionFromSampleDatasetError, connectionName);
    }
    return getDirectCopyErrorMessage(stringResources.To, conditionTemplate, fieldName, connectionName, pattern, addSuggestion);
}

export function getDirectCopyErrorMessage(
    directionLabel: string,
    conditionTemplate: string,
    fieldName: string,
    connectionName: string,
    pattern: 'onlySupport' | 'notSupport' = 'onlySupport',
    addSuggestion: boolean = true
): string {
    return (
        format(stringResources.Connection_DirectCopy_Template, directionLabel.toLocaleLowerCase(), connectionName) +
        format(
            pattern === 'onlySupport'
                ? stringResources.DirectCopyOnlySuppported_ErrorTemplate
                : stringResources.DirectCopyNotSuppported_ErrorTemplate,
            format(conditionTemplate, fieldName)
        ) +
        (addSuggestion
            ? format(stringResources.CopyCommand_CopyMethod_CopyCommandPleaseFixTemplate, fieldName)
            : '')
    );
}

// eslint-disable-next-line @typescript-eslint/member-ordering
export function formatSQLDWMessage(sink: CopySink, resourceTemplate: string, ...formatArgs: string[]): string {
    const finalLabel =
        sink instanceof SqlPoolSink
            ? stringResources.SQLPool
            : Metamodel.modelOf(sink)?.name === CopyActivity.getWarehouseModelType().copySinkType
            ? stringResources.DataWarehouse_DisplayText
            : stringResources.AzureSynapseAnalytics;
    return format(resourceTemplate, finalLabel, ...formatArgs);
}

export function getCopyCommandErrorMessage(
    activity: CopyActivity,
    conditionTemplate: string,
    fieldName: string,
    pattern: 'onlySupport' | 'notSupport' = 'onlySupport',
    addSuggestion: boolean = true
): string {
    const sourceDataset = activity.sourceDataset;
    if (sourceDataset?.isSampleDataset) {
        return formatSQLDWMessage(
            activity.copySink,
            stringResources.CopyCommand_SampleDatasetPleaseFixTemplate
        );
    }
    return (
        formatSQLDWMessage(
            activity.copySink,
            pattern === 'onlySupport'
                ? stringResources.CopyCommand_CopyMethod_CopyCommandOnlySupported_Error_Template
                : stringResources.CopyCommand_CopyMethod_CopyCommandNotSupported_Error_Template
        ) +
        format(conditionTemplate, fieldName) +
        (addSuggestion
            ? format(stringResources.CopyCommand_CopyMethod_CopyCommandPleaseFixTemplate, fieldName)
            : '')
    );
}

export function getSnowflakeCopyMethodValidationMessage(
    prefix: string,
    isV1: boolean,
    directionLabel: string = '',
): string {
    return (
        prefix + // direct copy / staging copy
        format(
            !isV1
                ? stringResources.CopyMethod_Suppported_ErrorTemplate
                : stringResources.DirectCopyOnlySuppported_ErrorTemplate,
            format(
                stringResources.Snowflake_CopyMethod_Validation_Error,
                directionLabel.toLocaleLowerCase(),
                __IS_FABRIC_DPE__
                    ? stringResources.AuthenticationType_SAS
                    : stringResources.SasUri
            )
        ) + 
        (!isV1
            ? stringResources.Snowflake_StorageIntegration_Validation_Message
            : '')
    )
}
